export const initialState = () => ({
  filters: {
    //Collection
    academicYears: [],
    regions: [],
    districts: [],
    schools: [],
    questionnaireStatus: [
      {
        id: 0,
        name: 'Todos',
        value: '',
      },
      {
        id: 1,
        name: 'No Entrevistado',
        value: '-1',
      },
      {
        id: 2,
        name: 'Cuestionario Sometido',
        value: '1',
      },
      {
        id: 3,
        name: 'En Proceso',
        value: '0',
      },
    ],
  },
  model: {
    //Selected Filters
    selectedAcademicYear: null,
    searchText: null,
    studentSie: null,
    selectedQuestionary: null,
    selectedRegions: null,
    selectedDistrict: null,
    selectedSchool: null,
    startRowIndex: null,
    maxRowIndex: null,
    advancedFilter: false,
  },
  results: [],
  paging: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
    pageSize: 10,
  },
  configPaginated: {
    pageSize: 10,
  },
});

export const state = initialState();
